import teamAddTemplate from './teamAdd.html';
import teamDetailTemplate from './teamDetail.html';
import teamMemberDetailTemplate from './teamMemberDetail.html';

const teamConfig = ($stateProvider) => {
    $stateProvider
        .state('teamDetail', {
            url: '/teamDetail',
            template: teamDetailTemplate,
            controller: 'TeamDetailController',
            controllerAs: 'team'
        })
        .state('teamAdd', {
            url: '/teamAdd',
            template: teamAddTemplate,
            controller: 'TeamAddController',
            controllerAs: 'team'
        })
        .state('member', {
            url: '/member/:memberId',
            template: teamMemberDetailTemplate,
            controller: 'TeamMemberDetailController',
            controllerAs: 'member'
        });
};

export default teamConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/team/team.config.js
 **/